/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useState } from "react";

import { storagePrefix } from "../../utils/storage";
import { IDoctorPlaces } from "../../types/doctor";
import { IDates } from "../../types/SearchAvalilableTimes";
import { IDoctorData } from "../doctorsData/types";
import {
  IScheduleDetails,
  IScheduleDetailsIntern,
  IScheduleInfos,
  IScheduleProps,
  IScheduleProvider,
} from "./types";

export const ScheduleContext = createContext<IScheduleProvider>(
  {} as IScheduleProvider
);

export const ScheduleProvider = ({ children }: IScheduleProps) => {
  const scheduleInfos: IScheduleInfos = {
    doctor: {} as IDoctorData,
    place: {} as IDoctorPlaces,
    schedule: {} as IDates,
    scheduleDetails: {} as IScheduleDetailsIntern,
    isVideo: false,
  };

  const [stateScheduleInfos, setStateScheduleInfos] =
    useState<IScheduleInfos>(scheduleInfos);

  const clearScheduleInfos = () => {

    scheduleInfos.doctor = {} as IDoctorData;
    scheduleInfos.place = {} as IDoctorPlaces;
    scheduleInfos.schedule = {} as IDates;
    scheduleInfos.scheduleDetails = {} as IScheduleDetailsIntern;
    scheduleInfos.isVideo = false;

    localStorage.removeItem(`${storagePrefix}scheduleInfo`);

    return;
  };

  const saveScheduleInfosInLocalStorage = () => {

    const { doctor, place, schedule, scheduleDetails } = scheduleInfos;

    localStorage.setItem(
      `${storagePrefix}scheduleInfo`,
      JSON.stringify({
        idDoctor: doctor.id,
        idPlace: place.id,
        schedule: schedule,
        details: scheduleDetails,
      })
    );
  };

  return (
    <ScheduleContext.Provider
      value={{
        stateScheduleInfos,
        setStateScheduleInfos,
        scheduleInfos,
        clearScheduleInfos,
        saveScheduleInfosInLocalStorage,
      }}
    >
      {children}
    </ScheduleContext.Provider>
  );
};

export const useScheduleInfos = () => useContext(ScheduleContext);
